var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showValue)?_c('div',{staticClass:"plain-argument"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))])]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }